export const films = [
  {
    id: "xin-jin-ping-mei-feng-yue",
    title: "新金瓶梅·风月宝鉴",
    type: "movies",
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    director: "陈砚舟",
    cast: ["柳映雪", "周牧然", "林婉君"],
    genres: ["古装", "剧情", "家族"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20graceful%20noblewoman%20holding%20an%20antique%20bronze%20mirror%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-01&orientation=portrait",
    summary:
      "一面古镜牵出望族深宅的三代恩怨，繁华表象下暗流涌动，映照出人心的欲望与挣扎。",
    plot: [
      "故事发生在江南一座富庶的商贾宅院。女主沈映雪自幼被寄养于望族西门府，凭着一手精湛的绣艺与过人的心思，在深宅之中周旋求生。一面相传能照见人心的古董铜镜，成为牵动全宅命运的引线。",
      "随着家族掌权者的衰老，几位当家子嗣围绕家业明争暗斗，往昔被掩埋的旧事逐一浮出水面。映雪在情义与自保之间反复抉择，最终以一场看似平静的家宴，为自己与身边的人讨回了迟到的公道。",
      "全片以细腻的镜头语言刻画人性的复杂，借一面镜子映照出欲望、隐忍与救赎，在古典叙事中投射出关于尊严与选择的现代思考。",
    ],
    releaseDate: "2024-11-08",
    popularity: 98,
    featured: true,
  },
  {
    id: "lan-ling-chun-qiu",
    title: "兰陵春秋",
    type: "movies",
    year: 2023,
    region: "中国大陆",
    rating: 8.9,
    director: "顾长鸣",
    cast: ["沈砚", "白清栀", "陆行舟"],
    genres: ["古装", "历史", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20young%20warrior%20prince%20in%20layered%20ceremonial%20armor%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-02&orientation=portrait",
    summary:
      "少年将军临危受命，于乱世之中力挽狂澜，一场关于家国、谋略与信念的史诗博弈。",
    plot: [
      "边关告急，朝堂暗流汹涌。出身将门的青年将领萧承烈临危受命，接掌一支几乎被放弃的残军。他既要面对强敌压境，也要在庙堂的算计中为将士争取一线生机。",
      "在漫长的对峙与周旋中，萧承烈逐渐看清战争背后真正的推手，也重新理解了父辈留下的信念。他与谋士白清栀并肩，以最小的代价换取了百姓的安宁。",
      "影片以恢弘的场面调度与克制的人物刻画，讲述理想在现实洪流中的坚守与代价。",
    ],
    releaseDate: "2023-09-15",
    popularity: 95,
    featured: false,
  },
  {
    id: "qi-luo-jie",
    title: "绮罗劫",
    type: "movies",
    year: 2022,
    region: "中国香港",
    rating: 8.2,
    director: "许映珊",
    cast: ["何芷宁", "江慕辰", "苏晚"],
    genres: ["古装", "悬疑", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20elegant%20lady%20behind%20a%20beaded%20silk%20curtain%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-03&orientation=portrait",
    summary:
      "一件织满暗纹的华服，牵连出连环谜案；绣坊深处的秘密，比针脚更细密难解。",
    plot: [
      "城中首屈一指的绣坊接下了一桩神秘订单，要求赶制一件纹样奇特的嫁衣。绣娘苏晚在整理图样时发现，衣上的暗纹竟与数月前的一桩旧案暗暗吻合。",
      "随着调查深入，绣坊内外的人心也随之松动。看似柔弱的女子们联手揭开层层伪装，让隐藏在锦绣之下的真相无处遁形。",
      "影片将悬疑推理与古典美学结合，以服饰纹样为线索，编织出一张关于秘密与救赎的网。",
    ],
    releaseDate: "2022-12-02",
    popularity: 88,
    featured: false,
  },
  {
    id: "chang-ye-jiang-ming",
    title: "长夜将明",
    type: "movies",
    year: 2025,
    region: "中国大陆",
    rating: 9.0,
    director: "宋亦寒",
    cast: ["顾清和", "许知遥", "程砚秋"],
    genres: ["悬疑", "推理", "年代"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20determined%20detective%20in%20long%20dark%20overcoat%20under%20lantern%20light%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-04&orientation=portrait",
    summary:
      "民国旧城连环疑案，一名执拗的探长循着一枚棋子，走进长夜里最深的真相。",
    plot: [
      "旧城冬夜，接连发生几起看似毫无关联的案件。探长陆知遥注意到现场留下的同一枚棋子，线索将他引向一座早已废弃的戏楼。",
      "调查越是深入，越触碰到城里盘根错节的关系网。陆知遥在孤立无援中坚持追查，靠逻辑与耐心一点点拼出真相的全貌。",
      "影片以沉稳的节奏与讲究的时代质感，讲述一个人如何在暗夜里守住心中那点微光。",
    ],
    releaseDate: "2025-01-20",
    popularity: 99,
    featured: true,
  },
  {
    id: "jin-ling-jiu-meng",
    title: "金陵旧梦",
    type: "movies",
    year: 2021,
    region: "中国台湾",
    rating: 7.9,
    director: "郑若怀",
    cast: ["温静姝", "方屹", "唐蕊"],
    genres: ["剧情", "文艺", "年代"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20melancholic%20woman%20with%20paper%20umbrella%20in%20old%20southern%20city%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-05&orientation=portrait",
    summary:
      "一封迟到多年的家书，让离乡的游子重回旧城，在斑驳巷影里重逢散落的亲情。",
    plot: [
      "旅居海外的女子林静姝返回故乡，整理已故祖母留下的旧宅。一封未能寄出的家书，揭开了家族数十年前的离散往事。",
      "她循着信中的地名走访老街，与故人重逢，也重新认识了自己与这座城的关系。旧梦虽已远去，记忆却在一砖一瓦间温热起来。",
      "影片以缓慢而温柔的叙事，描摹城市化浪潮中个体与故乡之间难以割舍的牵绊。",
    ],
    releaseDate: "2021-06-18",
    popularity: 76,
    featured: false,
  },
  {
    id: "hua-jian-ling",
    title: "花间令",
    type: "movies",
    year: 2024,
    region: "中国大陆",
    rating: 8.4,
    director: "叶知秋",
    cast: ["苏栖月", "谢云舟", "裴清"],
    genres: ["古装", "言情", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20refined%20court%20lady%20arranging%20blossoms%20in%20a%20jade%20vase%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-06&orientation=portrait",
    summary:
      "深宫花事亦是棋局，一枚花令签，牵动两个家族与一颗不羁的心。",
    plot: [
      "宫中的花宴历来是明争暗斗的舞台。初入宫闱的花匠之女苏栖月，凭一手精妙的插花技艺得到赏识，却被卷入一场围绕储位的暗局。",
      "她与清冷自持的侍卫统领谢云舟从相互试探到彼此信任，在层层算计间寻得一线真意。花开花落之间，有人成就大义，也有人放下执念。",
      "影片以花令为引，将宫廷权谋与细腻情感交织，画面考究，气韵清雅。",
    ],
    releaseDate: "2024-05-30",
    popularity: 91,
    featured: false,
  },
  {
    id: "yu-lou-chun-hua",
    title: "玉楼春华",
    type: "movies",
    year: 2020,
    region: "中国香港",
    rating: 7.6,
    director: "冯洛山",
    cast: ["林宝仪", "秦子墨", "柳含烟"],
    genres: ["古装", "家族", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20matriarch%20in%20embroidered%20robe%20on%20a%20carved%20wooden%20stair%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-07&orientation=portrait",
    summary:
      "一座玉楼见证三代女眷的兴衰，荣华背后，是她们各自的选择与坚守。",
    plot: [
      "玉楼是城中最气派的宅邸，也是几代女眷生活、争斗与和解的地方。掌家的老太太以铁腕维系家族体面，却难掩后继乏人的隐忧。",
      "年轻的孙媳柳含烟带着新式的想法走进这座老宅，与传统观念发生碰撞。在一场突如其来的变故后，女眷们不得不放下成见，共同撑起摇摇欲坠的家。",
      "影片以女性群像为轴，借一座楼院的兴衰，写尽时代变迁中的坚守与成长。",
    ],
    releaseDate: "2020-03-12",
    popularity: 70,
    featured: false,
  },
  {
    id: "jiang-hu-ye-yu",
    title: "江湖夜雨十年灯",
    type: "movies",
    year: 2023,
    region: "中国台湾",
    rating: 8.7,
    director: "罗砚青",
    cast: ["段无涯", "沈璧君", "柳惊鸿"],
    genres: ["武侠", "动作", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20swordsman%20standing%20in%20falling%20rain%20at%20night%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-08&orientation=portrait",
    summary:
      "十年前的一诺，换十年后的一场重逢；剑光落处，恩怨与情义同时有了答案。",
    plot: [
      "退隐多年的剑客段无涯本以为可以就此了却江湖事，一封旧友来信却让他不得不重出。为赴当年之约，他穿越千里，卷入一场早已布置好的局。",
      "一路上，他与旧识沈璧君重逢，也直面当年未解的心结。恩怨在剑光与夜雨中被逐一剖开，最终留下的不是胜负，而是放下。",
      "影片动作设计干净利落，文戏含蓄克制，写尽了江湖人的孤独与信义。",
    ],
    releaseDate: "2023-11-25",
    popularity: 93,
    featured: false,
  },
  {
    id: "fu-sheng-ji",
    title: "新金瓶梅·浮生记",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    rating: 8.8,
    director: "周慕白",
    cast: ["柳映雪", "徐砚之", "白若薇"],
    genres: ["古装", "家族", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20noblewoman%20surrounded%20by%20candlelit%20family%20hall%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-09&orientation=portrait",
    summary:
      "长篇剧集延续经典家族叙事，以一群人的浮沉，写尽一宅之内的人情冷暖与世道起落。",
    plot: [
      "剧集以一座临河而建的大宅为中心，讲述府中上下数十口人十余年间的命运流转。初来乍到的女眷沈氏凭聪慧与分寸站稳脚跟，也成为宅中众人的依靠。",
      "随着时局更迭、家道起落，宅中诸人的关系不断被重新洗牌。有人背叛旧情，有人守诺到底，也有人在浮沉之后选择了离开。",
      "全剧群像饱满、台词讲究，以生活化的细节构建出一个既古典又真实的世界。",
    ],
    releaseDate: "2025-02-14",
    popularity: 96,
    featured: true,
  },
  {
    id: "ting-yuan-shen-shen",
    title: "庭院深深",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    rating: 7.8,
    director: "何知许",
    cast: ["宋清欢", "陆沉", "叶知微"],
    genres: ["年代", "情感", "家族"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20quiet%20woman%20gazing%20from%20a%20deep%20courtyard%20window%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-10&orientation=portrait",
    summary:
      "深宅里的一场漫长守候，两代人的情感纠葛，在庭院的光影间缓缓铺展。",
    plot: [
      "旧式大家庭里，年轻的女主人宋清欢在丈夫常年缺席的日子里，独自打理宅院、抚育子女，把心事藏进每一个寻常的清晨与黄昏。",
      "随着时代的变迁，孩子们各自走向不同的人生，她也在一次意外的重逢里，重新审视自己多年的坚守究竟意味着什么。",
      "剧集以温缓的笔触描摹岁月流转，把一段寻常又不寻常的家庭史讲得格外动人。",
    ],
    releaseDate: "2022-08-08",
    popularity: 74,
    featured: false,
  },
  {
    id: "chun-gui-meng",
    title: "春闺梦",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    rating: 8.1,
    director: "白景行",
    cast: ["顾昭华", "季云舟", "温宁"],
    genres: ["古装", "言情", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20young%20bride%20in%20spring%20garden%20with%20peach%20blossoms%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-11&orientation=portrait",
    summary:
      "一场春日里的婚约，牵扯出两府旧怨；梦醒时分，爱恨皆需自己作结。",
    plot: [
      "名门之女顾昭华在桃花盛开的季节许下婚约，却不知这桩亲事背后牵动着两府多年的积怨。她以柔韧的姿态周旋其间，悄悄改变着所有人的命运。",
      "随着旧怨浮出水面，她与意中人季云舟不得不直面家族与真心之间的抉择。历经波折，两人终于以各自的方式守住了心中的春天。",
      "剧集服化道精致，节奏张弛有度，把古典言情拍得既浪漫又有筋骨。",
    ],
    releaseDate: "2023-04-19",
    popularity: 82,
    featured: false,
  },
  {
    id: "hai-shang-hua",
    title: "海上花列传",
    type: "tv",
    year: 2021,
    region: "中国香港",
    rating: 8.3,
    director: "岑婉如",
    cast: ["蓝蔚", "薛慕青", "卓一鸣"],
    genres: ["年代", "剧情", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20group%20of%20elegant%20women%20in%201930s%20Shanghai%20ballroom%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-12&orientation=portrait",
    summary:
      "浮华都市里的女子群像，她们在灯红酒绿间谋生，也在时代缝隙里谋一份体面。",
    plot: [
      "故事发生在上世纪三十年代的繁华都市。几位出身不同、性情各异的女子在一间声名远扬的茶楼相识，因缘际会成为彼此的依靠。",
      "她们在应酬与周旋中尝尽冷暖，也见证着都市的繁荣与暗面。有人凭智慧翻身，有人为情所困，也有人在时代浪潮里找到了新的人生方向。",
      "剧集以细腻的女性视角，勾勒出一幅生动的都市浮世绘，悲喜交织，余味悠长。",
    ],
    releaseDate: "2021-10-11",
    popularity: 79,
    featured: false,
  },
  {
    id: "xiu-chun-dao-xing",
    title: "绣春刀行",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    rating: 8.9,
    director: "凌寒声",
    cast: ["萧正", "云舒", "沈昭"],
    genres: ["古装", "悬疑", "动作"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20masked%20imperial%20guard%20with%20a%20long%20blade%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-13&orientation=portrait",
    summary:
      "一名京营缇骑奉命查案，却发现真相比刀锋更冷，比夜更黑。",
    plot: [
      "年轻的缇骑萧正奉命调查一桩离奇的官银失踪案，线索指向京城中一个庞大的秘密组织。他凭借冷静的判断和过人的身手，在重重疑云中步步深入。",
      "越是靠近核心，他越发现自己效忠的秩序并非铁板一块。在生死抉择面前，萧正选择忠于内心的判断，与同伴云舒联手揭开黑幕。",
      "剧集动作场面凌厉写实，案情环环相扣，兼具悬疑张力与时代质感。",
    ],
    releaseDate: "2024-07-06",
    popularity: 94,
    featured: false,
  },
  {
    id: "bai-lu-zhou",
    title: "白鹭洲",
    type: "tv",
    year: 2020,
    region: "中国台湾",
    rating: 7.5,
    director: "许砚清",
    cast: ["林栖", "周衍", "苏芩"],
    genres: ["文艺", "剧情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20woman%20walking%20alone%20on%20a%20misty%20riverside%20island%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-14&orientation=portrait",
    summary:
      "小岛上的四季更迭，记录一家人缓慢生长与彼此谅解的过程。",
    plot: [
      "白鹭洲是江心一座安静的小岛，岛上的林家靠着一片果园为生。长女林栖自小懂事，默默承担起照顾家人的责任，也压抑着自己远行的愿望。",
      "当多年未归的弟弟带着城里的烦恼回到岛上，一家人被搁置的矛盾重新被摆上台面。在四季的更替里，他们学着倾听、原谅，也学着放手。",
      "剧集节奏舒缓、画面宁静，像一杯温水，慢慢熨帖人心。",
    ],
    releaseDate: "2020-09-23",
    popularity: 66,
    featured: false,
  },
  {
    id: "qian-ji-bian",
    title: "千机变",
    type: "tv",
    year: 2025,
    region: "韩国",
    rating: 8.5,
    director: "金泰河",
    cast: ["车瑞元", "尹素熙", "姜志勋"],
    genres: ["犯罪", "悬疑", "都市"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20modern%20city%20detective%20in%20a%20rain%20soaked%20neon%20alley%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-15&orientation=portrait",
    summary:
      "一场精心设计的骗局牵出巨额疑案，刑警与骗子在都市夜色中展开博弈。",
    plot: [
      "首尔接连发生几起离奇的诈骗案，手法如出一辙却找不到幕后主使。刑警车瑞元在追查中发现，案件与他多年前未破的一桩旧案隐隐相连。",
      "为了接近真相，他不得不与一位身怀绝技的骗子合作。两人在信任与算计之间不断试探，最终揭开了一个惊人而精巧的布局。",
      "剧集节奏凌厉、反转密集，在都市犯罪的外壳下探讨正义与代价。",
    ],
    releaseDate: "2025-03-21",
    popularity: 90,
    featured: false,
  },
  {
    id: "jin-tang-chun",
    title: "锦堂春",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    rating: 8.2,
    director: "苏穆远",
    cast: ["沈青鸾", "慕长歌", "裴玉书"],
    genres: ["古装", "家族", "言情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20Chinese%20historical%20costume%20drama%2C%20noble%20lady%20in%20a%20grand%20embroidered%20hall%20with%20lanterns%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20palette%2C%20textured%20minimal%20misty%20background%2C%20painterly%20digital%20illustration%2C%20refined%20and%20tasteful%2C%20high%20detail%2C%20balanced%20composition%2C%20cinematic%20poster%20format&width=600&height=900&seq=film-16&orientation=portrait",
    summary:
      "掌家女主以绣坊为业，凭一双手守住家业，也在乱世里守住了自己的名字。",
    plot: [
      "沈青鸾嫁入经营绣坊的慕家，本以为只是安稳度日，却在新婚不久直面家业衰败的困境。她凭过硬的手艺与果决的判断，一步步把绣坊重新撑了起来。",
      "在商海与人情的双重磨炼中，她与丈夫慕长歌从生疏走向并肩。锦堂之上，春意渐浓，属于她的故事也才刚刚展开。",
      "剧集以家族经商为主线，兼有细腻情感，展现了一位古典女性自立自强的成长。",
    ],
    releaseDate: "2023-06-28",
    popularity: 85,
    featured: false,
  },
];